import {Component, Fragment, h} from "preact";
import {AppPage} from "../_common/components/app-page";
import {connect} from "react-redux";
import {t} from '../_i18n';
import {C, CF, E, F, FR, R, RE} from "../_common/layout";
import {CompanyCompany, CompanyNewCompany, CompanyOffer} from "../_api";
import { saveNewCompany} from "../_rx/jobs/actions";
import {Field, Form as FinalForm} from "react-final-form";
import {
    FormField,
    FormFieldTextArea, SubmitButtonRow
} from "../_common/forms/components/components";
import {Helmet} from "react-helmet";
import {NEW_COMPANY_TITLE_PAGE} from "../constants";
import AlertBox from "../_common/components/AlertBox/AlertBox";

type Props = {company:CompanyCompany, saveNewCompany:typeof saveNewCompany};


class View extends Component<Props,{sent:boolean}> {

    state = {sent: false}

    async onSubmit(company:CompanyNewCompany){
        await this.props.saveNewCompany(company);
        this.setState({sent:true});
    }

    render({ }:Props) {

        return this.state.sent ? <Fragment>
            <F className='max-width-sm'>
                <AlertBox type='success'>
                    <span>Gracias!</span>
                </AlertBox>
            </F>
        </Fragment> : <FinalForm
            onSubmit={(data:CompanyNewCompany)=>this.onSubmit(data)}
            render={({handleSubmit,  submitting, values, pristine, submitSucceeded}:any)=>
                <form className='form' action="" onSubmit={handleSubmit}  noValidate>
                    <Helmet>
                        <title>{NEW_COMPANY_TITLE_PAGE}</title>
                    </Helmet>
                    <F className='max-width'>
                    <Fragment>
                        <C>
                            <h2 className="m-bottom">Información de la empresa</h2>

                            <RE><FormField label={'Nombre'} name="name" required /></RE>
                            <R className="sm-row-3-el row-1-el">
                                <E><FormField label={'NIF'} name="nif" required /></E>
                            </R>

                            <RE>
                            <FormFieldTextArea label={'Descripción'} rows={10} name="text" required />
                            </RE>

                            <hr className="separator-xxs"/>

                            <h2 className="m-bottom">Datos de contacto</h2>

                            <R>
                                <E><FormField label={'Email'} name="contactEmail" required /></E>
                            </R>
                            <R className="sm-row-3-el row-1-el">
                                <E><FormField label={'Contraseña'} name="contactPassword" type="password" required /></E>
                                <E><FormField label={'Confirmar contraseña'} name="contactPasswordConfirm" type="password" required /></E>
                            </R>
                            <R>
                                <E><FormField label={'Nombre'} name="contactName" required /></E>
                                <E><FormField label={'Apellidos'} name="contactSurname" required /></E>
                                <E><FormField label={'Teléfono'} name="contactPhone" required /></E>
                            </R>
                        </C>

                        <C>
                            <SubmitButtonRow disabled={submitting}>Enviar</SubmitButtonRow>
                        </C>
                    </Fragment>
                </F>
                </form>}/>;
    }
}

const ConnectedView: any = connect(
    ()=>({}), {saveNewCompany})(View as any);

export default () =>
    <AppPage
        name="company-new"
        title={t('Registro')}
        subtitle=""
        className="max-width">
        <ConnectedView />
    </AppPage>
;

